/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Joor_Order_Not_ApplicableInputs */

const en_error_joor_order_not_applicable = /** @type {(inputs: Error_Joor_Order_Not_ApplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This order of Joor cannot be applied: read what it still lacks.`)
};

/**
* | output |
* | --- |
* | "This order of Joor cannot be applied: read what it still lacks." |
*
* @param {Error_Joor_Order_Not_ApplicableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_joor_order_not_applicable = /** @type {((inputs?: Error_Joor_Order_Not_ApplicableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Joor_Order_Not_ApplicableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_joor_order_not_applicable(inputs)
});